import {
    isAndroid,
    isMobile,
    isMobileSafari,
    isIOS,
    getSelectorsByUserAgent
} from 'react-device-detect';
import { nullifyUndefinedProperties } from 'tradera/utils/object';
import { isServer } from 'tradera/utils/nextjs';
import { getNativeAppSupport } from './native-app-support';
import { DEFAULT_USER_AGENT } from 'tradera/apps/nextweb/utils/viewport';

export const getInitialServerState = ({
    environmentHash,
    experiments = [],
    featureToggles = {},
    splitTestGroups = {},
    variables = {},
    version,
    userAgent,
    appOsVersion = '',
    hybridAppDevice = '',
    hybridAppVersion = '',
    isNativeAppContext = false,
    isHybridAppContext = false,
    appInstanceId = '',
    gaTrackingSessionId = ''
} = {}) => {
    const { isMobile, isMobileSafari, isIOS, browserName } =
        getSelectorsByUserAgent(userAgent || DEFAULT_USER_AGENT);

    return {
        ...getNativeAppSupport({
            isNativeAppContext,
            isHybridAppContext,
            hybridAppDevice,
            hybridAppVersion,
            appOsVersion,
            isIOS,
            isAndroid
        }),
        browserName,
        isNativeAppContext,
        hybridAppVersion,
        environment: process.env.NODE_ENV,
        experiments,
        isHybridAppContext,
        isIOS,
        isMobileDevice: isMobile,
        isMobileSafari,
        isSpaNavigationEnabled: true,
        featureSwitches: featureToggles,
        splitTestGroups,
        variables,
        environmentHash,
        version,
        appInstanceId,
        gaTrackingSessionId
        // TODO: Fetch values for below
        // splitTests,
    };
};

export const initEnvironment = () => {
    return nullifyUndefinedProperties({});
};

export default ({
    appOsVersion,
    environment,
    environmentHash,
    experiments,
    featureSwitches,
    googleAnalyticsTrackingId,
    googleAnalyticsMeasurementId,
    geoPublicApiBaseUrl,
    hybridAppDevice,
    hybridAppVersion,
    isHybridAppContext,
    isNativeAppContext,
    isSinglePageApp,
    splitTests,
    splitTestGroups,
    version,
    webLiveUrl,
    appInstanceId,
    gaTrackingSessionId
}) => {
    return nullifyUndefinedProperties({
        ...getNativeAppSupport({
            isNativeAppContext,
            isHybridAppContext,
            hybridAppDevice,
            hybridAppVersion,
            appOsVersion,
            isIOS,
            isAndroid
        }),
        environment,
        experiments,
        featureSwitches,
        environmentHash,
        isHybridAppContext,
        appInstanceId,
        isIOS,
        isNativeAppContext,
        isMobileDevice: isMobile,
        isMobileSafari,
        isSpaNavigationEnabled:
            !isServer &&
            isSinglePageApp &&
            !isHybridAppContext &&
            !window.frameElement
                ? true
                : false, // No SPA navigation in native apps or iFrame
        splitTests,
        splitTestGroups,
        variables: {
            // Names must be the same as NextWeb's .env variables
            PUBLIC_GOOGLE_ANALYTICS_TRACKING_ID: googleAnalyticsTrackingId,
            PUBLIC_GOOGLE_ANALYTICS_MEASUREMENT_ID:
                googleAnalyticsMeasurementId,
            PUBLIC_GEO_PUBLIC_API_BASE_URL: geoPublicApiBaseUrl,
            PUBLIC_WEB_LIVE_URL: webLiveUrl
        },
        version,
        gaTrackingSessionId
    });
};
